const PAYMENT_STATUS_APROBADO = 'aprobado';
const PAYMENT_STATUS_CANCELADO = 'cancelado';
const PAYMENT_STATUS_RECHAZADO = 'rechazado';

module.exports = {
  PAYMENT_STATUS_APROBADO,
  PAYMENT_STATUS_CANCELADO,
  PAYMENT_STATUS_RECHAZADO,
};
